define("shared/errors/unknown-route", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.UnknownRouteError = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  class UnknownRouteError extends Error {
    constructor(message) {
      super(message);
      this.name = 'UnknownRouteError';
    }
  }
  _exports.UnknownRouteError = UnknownRouteError;
});